

<div class="app flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">

        <img src="/assets/img/logo.png"/>

        <div class="card-group mb-4">
          <div class="card p-4">
            <div class="card-body">

              <div class="col-md-12 m-a-3">

                <div class="animated fadeIn">

                  <div class="row">

                    <div class="col-md-12 m-a-3">

                      <h2>Reset your password</h2>

                      <span style="color: red">{{errorMessage}}</span>
                      <span style="color: green">{{infoMessage}}</span>

                      <br/><br/>
                      <div class="card">
                        <div class="input-group mb-3">
                          <span class="input-group-addon">Your email:</span>
                        <input type="text" class="form-control" placeholder="@" [(ngModel)]="email" value="@">
                      </div>


                      <div class="mb-sm-2">
                        <button type="submit" class="btn btn-sm btn-primary" (click)="submit()" required><i class="fa fa-dot-circle-o"></i> Reset your password</button>

                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <button type="button" class="btn btn-link px-0" onclick="history.go(-1)">Back</button>

                      </div>



                    </div>

                  </div>
                </div>

              </div>
            </div>



          </div>
        </div>
      </div>


    </div>
  </div>
</div>





